<template>
  <div class="cots-extrabeds">
    <div class="cots-extrabeds__element" v-for="(values, key) in grouped_extras" :key="_uid + key">
      <p class="cots-extrabeds__element-title">{{ get_cots_extrabeds(key).name }}</p>
      <div class="cots-extrabeds__element-content">
        <div class="cots-extrabeds__item" v-for="(extra_bed, extra_bed_index) in values" :key="_uid + extra_bed_index">
          <div class="cots-extrabeds__item-wrap">
            <p class="cots-extrabeds__item-title">
              <strong>da {{extra_bed.age.from}}
                <span>{{ format_age(extra_bed.age) }}</span>
              </strong>
            </p>
            <div class="cots-extrabeds__item-content">
              <div class="d-flex align-items-center" :set_get_extra="get_extra_type = get_cots_extrabeds(extra_bed.type)">
                <vb-icon :name="get_extra_type.icon" :size="16" />
                <span class="ml-1">{{ get_extra_type.name }}</span>
                <vb-icon
                  v-if="get_extra_type.tooltip !== ''"
                  class="ml-1 mt-1" :name="'info'" :color="sass('gray-500')" :size="12"
                  v-b-popover.hover.top="get_extra_type.tooltip"
                />
              </div>
              <div v-if="extra_bed.price !== 0">
                <span v-html="'<em class=\'text--sm\'>' + currency + '</em>' + ' ' + extra_bed.price" />
                <span v-if="extra_bed.mode === 'per_night'"> a notte</span>
              </div>
              <span v-else>Gratis</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_cots_extrabeds } from '@bookingv3/resources'

export default {
  name: 'cots-extrabeds',

  components: {
  },

  props: {
    extra: Array,
    currency: String,
  },

  data() {
    return {
    }
  },

  computed: {
    grouped_extras() {
      return this.group_by_rate_type(this.extra)
    }
  },

  created() {
    this.get_cots_extrabeds = get_cots_extrabeds
  },

  mounted() {
  },

  methods: {

    // Raggruppa per tipologia (culle, letti supplementari etc)
    group_by_rate_type(data) {
      const result = {}
      data.forEach(item => {
        const type = item.type
        if (!result[type]) result[type] = []

        result[type].push(item)
      })
      return result
    },

    format_age(age) {
      return age.to ? `a ${age.to} anni` : 'anni e oltre'
    }

  },
}
</script>

<style lang="scss" scoped>

  .cots-extrabeds {

    &__element {
      margin-top: 15px;

      &:first-child {
        margin-top: 0;
      }

      &-title {
        margin-bottom: 0;
        padding: 0 3px;
        line-height: normal;
        font-weight: $vb-font-weight-semibold;
        color: $gray-600;
      }

      &-content {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -5px;
      }
    }

    &__item {
      padding: 10px 5px 0 5px;
      flex-basis: 50%;

      &-wrap {
        border: 1px solid $gray-200;
        border-radius: 10px;
        overflow: hidden;
      }

      &-title {
        border-bottom: 1px solid $gray-200;
        padding: 5px 15px;
        margin-bottom: 0;
        background-color: #f0f6ff;

        strong {
          font-weight: $vb-font-weight-semibold;
        }
      }

      &-content {
        display: flex;
        padding: 10px 15px;
        background-color: #fafcff;

        & > * {

          &:first-child {
            flex-basis: 70%;
          }

          &:last-child {
            text-align: right;
            flex-basis: 30%;
          }
        }
      }
    }
  }

</style>